<script lang="ts">
	interface Props {
		label: string;
		id?: string;
		children?: import('svelte').Snippet;
	}

	let { label, id = '', children }: Props = $props();
</script>

<div class="flex flex-col gap-1">
	{#if id}
		<label for={id} class="font-semibold">{label}</label>
	{:else}
		<span class="font-semibold">{label}</span>
	{/if}
	{@render children?.()}
</div>
